<template>
  <Modal title="请假单" v-model="showCreate" class-name="vertical-center-modal" :mask-closable="false" width="680px" @on-cancel="close()">
    <template>
      <Form ref="leaveFrom" :model="leaveFrom" :rules="ruleLeaveFrom" :label-width="100" label-position="right">
		  <FormItem label="姓名:" prop="name">
			  <Row :gutter="20">
			    <Col span="20">
				 <Input v-model="leaveFrom.name" placeholder="请输入员工姓名" style="width:525px" ></Input>
		    <!-- <Input v-model="leaveFrom.name" placeholder="员工姓名" style="width:525px"></Input> -->
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="工号:" prop="number">
			  <Row :gutter="20">
			    <Col span="20">
		    <Input v-model="leaveFrom.number"  style="width:525px" placeholder="请输入工号"></Input>
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="部门:" prop="departmentIds">
			  <Row :gutter="20">
			    <Col span="20">
					<selectTree v-model="leaveFrom.departmentIds"  style="width:525px" :disabled="true" :treeData="treeData" @on-select-change="selectChange" @on-remove="removeRoot" :showQuery='false' ></selectTree>
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="岗位:" prop="post">
		  			  <Row :gutter="20">
		  			    <Col span="20">
		    <Select placeholder="请选择岗位"  style="width:525px" v-model="leaveFrom.post">
		      <Option value="">------</Option>
		      <Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
		    </Select>
		  			</Col>
		  			</Row>
		  </FormItem>
		  <FormItem label="工作代理人:" prop="workAgent">
			  <Row :gutter="20">
			    <Col span="20">
		    <Input v-model="leaveFrom.workAgent"  style="width:525px" placeholder="请输入工作代理人"></Input>
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="请假事由：" prop="title">
			  <Row :gutter="20">
			    <Col span="20">
		    <Input type="textarea" v-model="leaveFrom.title" placeholder="请输入请假事由 " style="width:525px" maxlength="200" />
			</Col>
			</Row>
		  </FormItem>
        <FormItem label="请假类型：" prop="leaveType">
          <Row :gutter="20">
            <Col span="20">
            <Tooltip content="若涉及同时申请多种假期，每类假期需单独发起申请" max-width="450" :always="alwasyTool" placement="top-start">
              <Select v-model="leaveFrom.leaveType" style="width:525px">
                <Option v-for="item in leaveTypeList" :value="item.value" :key="item.name">{{ item.name }}</Option>
              </Select>
            </Tooltip>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="开始时间：" prop="startDate">
          <!-- v-model="leaveFrom.startDate" -->
          <Row :gutter="20">
            <Col span="18">
            <DatePicker type="date" placeholder="请选择开始时间 " style="width: 100%" :editable="false" @on-change="leaveFrom.startDate = $event" :value="leaveFrom.startDate" />
            </Col>
            <Col span="2">
            <Select v-model="leaveFrom.startDateArea" style="width: 100px;">
              <Option v-for="item in leaveTimeList" :value="item.value" :key="item.name">{{ item.name }}</Option>
            </Select>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="结束时间：" prop="endDate">
          <!-- v-model="leaveFrom.endDate" -->
          <Row :gutter="20">
            <Col span="18">
            <DatePicker type="date" placeholder="请选择结束时间 " style="width: 100%" :editable="false" @on-change="leaveFrom.endDate = $event" :value="leaveFrom.endDate" />
            <!-- <font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> -->
            </Col>
            <Col span="2">
            <Select v-model="leaveFrom.endDateArea" style="width: 100px;">
              <Option v-for="item in leaveTimeList" :value="item.value" :key="item.name">{{ item.name }}</Option>
            </Select>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="请假时长：" prop="timeCount" style="margin-bottom:5px">
          <Row :gutter="20">
            <Col span="20">
              <Input type="text" :value="leaveFrom.timeCount" placeholder="请假时长 " style="width:525px" readonly>
              <span slot="append">天</span></Input>
              <Input type="text" v-model="timeCount" style="display: none;" />
            </Col>
          </Row>
        </FormItem>
      </Form>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </template>
    <div slot="footer">
      <Button @click="close()">取消</Button>
      <Button type="warning" @click="onOk(false)" :disabled="BtnDisabled">保存草稿</Button>
      <Button type="primary" @click="onOk(true)" :disabled="BtnDisabled">提交</Button>
    </div>
  </Modal>
</template>
<script>
function endDateFun() {
  return false
}
import Ajax from '../../../lib/ajax'
import selectTree from '../../../components/selectTree/selectTree.vue'
import { getUserNames} from '../../../api/index';

export default {
  components: {
	  selectTree
  },
  props: {
    showCreate: { type: Boolean, default: false },
    leaveId: { type: Number, default: null },
	leaveTypeList: { type: Array, default: [] },
	postList: { type: Array, default: [] },
	isSelf:{type:Boolean,default:false}
  },
  data() {
    //判断请假日期
    const validateStartDate = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('日期不能为空'))
      } else {
        callback()
      }
    }
    //判断请假结束日期
    const validateEndDate = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('日期不能为空'))
      } else {
        let start_date = this.leaveFrom.startDate //开始时间
        if (start_date.getTime() > value.getTime()) {
          callback(new Error('结束日期不能小于开始日期'))
        } else {
          callback()
        }
      }
    }
    const validateLeaveType = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback(new Error('请假类型不能为空'))
      } else {
        callback()
      }
    }
	const validateDepartment = (rule, value, callback) => {
	  if (value === '' || value === undefined || value === null) {
	    callback(new Error('请假类型不能为空'))
	  } else {
	    callback()
	  }
	}
    //请假时长
    const validateLeaveTime = (rule, value, callback) => {
      if (value < 0) {
        callback(new Error('请假时长不能小于0'))
      } else {
        callback()
      }
    }
    return {
      spinShow: false,
      url: '',
      uploadList: [],
      modalLeave: false,
      BtnDisabled: false,
      alwasyTool: false,
	  isPersonnel:false,
	  treeData : [],
      leaveFrom: {
		name:'',
		post:null,
		department:'',
		departmentIds:null,
		number:'',
        title: '',
        userId: 0,
        startDate: '',
		workAgent:'',
        endDate: '',
        startDateArea: '上午',
        endDateArea: '上午',
        leaveType: '',
        timeCount: '',
		isSubmit:false,
		isSelfApply:this.isSelf,
      },
      leaveTimeList: [
        { value: '上午', name: '上午' },
        { value: '下午', name: '下午' },
      ],
	  loading1:false,
	  c人员List:[],
	  isDisable:false,
	  checkName:'',
      prev: '', //防抖
      ruleLeaveFrom: {
        title: [
          {
            required: true,
            message: '请假事由不能为空',
            trigger: 'blur',
          },
        ],
		name: [
		  {
		    required: true,
		    message: '员工姓名不能为空',
		    trigger: 'blur',
		  },
		],
		departmentIds : [
		  {
			  validator: (rule, value, callback)=>{
			  if(this.leaveFrom.departmentIds ){
				  callback()
			  }
			  else{
				 callback(new Error('请选择部门'))
			  }
			 },
			 required:true
		  ,}
		],
		// departmentIds: [{ required: true, message: '请选择部门', trigger: 'blur,change' }],
        startDate: [
          {
            required: true,
            pattern: /.+/,
            validator: validateStartDate,
            trigger: 'blur',
          },
        ],
        endDate: [
          {
            required: true,
            pattern: /.+/,
            // validator: validateEndDate,
            message: '日期不能为空',
            trigger: 'blur',
          },
        ],
        timeCount: [{ validator: validateLeaveTime, trigger: 'change' }],
        startDateArea: [
          {
            required: true,
            message: '开始时间不能为空',
            trigger: 'blur',
          },
        ],
        endDateArea: [
          {
            required: true,
            message: '结束时间不能为空',
            trigger: 'blur',
          },
        ],
        leaveType: [
          {
            required: true,
            validator: validateLeaveType,
            message: '请假类型不能为空',
            trigger: 'change',
          },
        ],
		workAgent: [
		  // { required: this.isRequiredWorkAgent, message: '请输入工作代理人', trigger: 'blur,change', type: 'string' },
		  {validator: (rule, value, callback)=>{
			  
			  if(this.leaveFrom.timeCount>=2&&this.leaveFrom.workAgent!=""){
				  callback()
			  }
			  else if(this.leaveFrom.timeCount<2){
			  	callback()
			  }else{
				 callback(new Error('请输入工作代理人'))
			  }
		  },}
		],
		number: [
		  { required: false, message: '请输入工号', trigger: 'blur,change', type: 'string' },
		],
		post: [{ required: true, message: '请选择岗位', trigger: 'blur,change', type: 'number' }]
      },
    }
  },
  
  methods: {
	  async getTree(){
	  		  let reponse=await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree');
	  		  // reponse.data.result[0].expand = true;
	  		  let dataResult = reponse.data.result;
	  		  console.log(dataResult);
	  	// let respone = this.$store.state.department.departmentTree;
	  	this.editeTreeValue(dataResult);
	  	this.treeData = dataResult; 
	  },
	  		organizationID(){
	  			this.leaveFrom.department = [];
	  		},
	  		selectChange(data){
	  			this.leaveFrom.department = data
	  		},
	  		removeRoot(data){
	  			this.leaveFrom.department = data
	  		},
	  		editeTreeValue(data){
	  			for (let i=0; i<data.length; i++) {
	  				data[i].title = data[i].displayName
	  				data[i].value = data[i].id
	  				if(data[i].children){
						if(data[i].children.length>0){
						   data[i].expand=true
						}
	  					this.editeTreeValue(data[i].children)
	  				}
	  			}
	  		},
	async getDetail(){
		let data = await this.$Ajax.get(`/api/services/app/Leave/GetDetailById`, {
		  params: { id: this.leaveId }
		})
		 this.leaveFrom = data.data.result
		 this.leaveFrom.isSelfApply=this.isSelf
		 this.getTree()
	},
	// 关闭弹窗
    close(refresh) {
      this.$refs['leaveFrom'].resetFields()
      this.$emit('close', refresh)
	  
	  this.handleReset('leaveFrom')
    },
    //ok
    async onOk(isTS) {
		console.log('leaveFrom',this.leaveFrom);
      this.$refs['leaveFrom'].validate(async (valid) => {
        if (valid) {
          if (this.leaveFrom.timeCount <= 0) {
            this.tpis('error', '请假时长必须大于0')
            return
          }
		  if(this.leaveFrom.departmentIds.length>0){
		  this.leaveFrom.department=this.leaveFrom.departmentIds.join(',')
		  }
          this.spinShow = true
          this.leaveFrom.isSubmit = true
          if (!isTS) {
            //暂存
            this.leaveFrom.isSubmit = false
          }
          let url = '/api/services/app/Leave/Create'
          let method = 'post'
          if (this.leaveId>0) {
            url = '/api/services/app/Leave/UpdateLeave'
          }
          try {
            let { data: respone } = await this.$Ajax[method](url, this.leaveFrom)
			this.close(true)
            if (respone.success) {
              this.tpis('success', '操作成功')
			  this.spinShow = false
            } else {
              this.tpis('error', '操作失败')
            }
          } catch (error) {
            this.BtnDisabled = false
            this.spinShow = false
          }
        } else {
        }
      })
    },
    submit() {},
    //清空表单验证
    handleReset(name) {
      this.$refs[name].resetFields()

      this.leaveFrom = {
        name:'',
        post:null,
        department:'',
        number:'',
        title: '',
        userId: 0,
        startDate: '',
        workAgent:'',
        endDate: '',
        startDateArea: '',
        endDateArea: '',
        leaveType: '',
        timeCount: '',
        isSubmit:false,
		isSelfApply:this.isSelf,
      }
      this.BtnDisabled = false
    },
    
    //提示弹窗
    tpis(type, content) {
      this.$Message[type]({
        background: true,
        content: content,
      })
    },
	 isCheck(e) {
            let _this = this;
            _this.c人员List.filter(el => {
                if (el.id == e) {
					_this.leaveFrom.department=el.department
					_this.leaveFrom.name=el.name
					_this.leaveFrom.number=el.number
					_this.leaveFrom.post=el.post
					_this.leaveFrom.userId=el.userId
                }
				            });        },
    //计算时长
    async computedTime() {
      let time = {
        startDate: this.leaveFrom.startDate,
        endDate: this.leaveFrom.endDate,
        startDateArea: this.leaveFrom.startDateArea,
        endDateArea: this.leaveFrom.endDateArea,
      }
      await this.$Ajax.post(`/api/services/app/Leave/CalcTimeCount`, time).then((res) => {
        let t = res.data.result
        this.leaveFrom.timeCount = t
        return t
      })
      return 0
    },
	async remoteMethod1 (query) {
	            
	            if (query !== '') {
	                this.loading1 = true;
	             let {data} =  await getUserNames(query)
	                    console.log("🚀 ~ file: createSale.vue:95 ~ remoteMethod1 ~ data:", data)
	                    this.loading1 = false;
	                    this.c人员List = data.result //= list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
	            } else {
	                this.c人员List = [];
	            }
	        },
  },
  computed: {
    // 定义计算属性totalPrice
    timeCount: function () {
      if (
        this.leaveFrom.endDateArea != '' &&
        this.leaveFrom.startDate != '' &&
        this.leaveFrom.endDate != '' &&
        this.leaveFrom.startDateArea != ''
      ) {
        this.computedTime()
      } else {
        return 0
      }
    },
  },
  mounted() {
	  if(this.leaveId>0){
		  this.getDetail()
	  }
	  else{
	  this.getTree()
	  }
  },

}
</script>

<style lang="less" scoped="scoped">
.ivu-spin-fix {
  z-index: 99999999;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .input_heigth {
    line-height: 30px;
    margin: 10px;
  }
}

.ivu-form-item {
  // margin-bottom: 16px;
}

.disabled {
  padding-left: 5px;
  background: #f3f3f3;
}

.forms {
  padding: 20px 30px;
}
.tips {
  color: #f60;
  font-size: 14px;
  // transform: scale(0.6);
  // display: inline-block;
  // position: absolute;
  // left: 21px;
  // top: 10px;
  // padding: 5px 0px;
  // left:-35px;
  // top: 25px;
}
</style>
